export default "__VITE_ASSET__ea8066ce__"